import React from 'react';
import { FileText as LucideFileText } from 'lucide-react';

interface FileTextProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const FileText: React.FC<FileTextProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideFileText width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default FileText;
